import React from 'react';

/**
 * @param {object} [stepGateMap] - optional map stepId -> { allowed: boolean, hint: string } for locked-step UX
 */
const HorizontalWorkflowStepper = ({ steps, activeStepId, onSelectStep, stepGateMap }) => {
    return (
        <div className="mb-6 w-full overflow-x-auto rounded-2xl border border-[color:var(--color-border)] bg-[var(--color-bg-white)] py-6 px-4 shadow-lg [-webkit-overflow-scrolling:touch]">
            <div className="flex min-w-max flex-nowrap items-start justify-between gap-2 px-2 sm:gap-3 md:w-full md:min-w-0 md:justify-between">
                {steps.map((s, i) => {
                    const isActive = s.id === activeStepId;
                    const isCompleted = s.status === 'completed';
                    const gate = stepGateMap?.[s.id];
                    const locked = gate && !gate.allowed;
                    return (
                        <React.Fragment key={s.id}>
                            <div className="flex flex-col items-center flex-shrink-0" style={{ minWidth: 80 }}>
                                <button
                                    type="button"
                                    onClick={() => onSelectStep(s.id)}
                                    title={locked ? gate.hint : undefined}
                                    className={`relative flex items-center justify-center focus:outline-none rounded-[1rem] transition-all ${
                                        locked ? 'opacity-45 cursor-not-allowed' : 'hover:opacity-95'
                                    }`}
                                >
                                    <div
                                        className={`w-14 h-14 rounded-[1rem] flex items-center justify-center font-black text-sm transition-all ${
                                            locked
                                                ? 'wf-tile bg-[color:var(--color-tile-todo-bg)] text-[color:var(--color-text-muted)] border border-dashed border-[color:var(--color-tile-todo-line)]'
                                                : isActive
                                                  ? 'wf-tile bg-[color:var(--color-tile-active-bg)] border-[1.5px] border-[color:var(--color-tile-active-line)] text-[color:var(--color-text-hero)] shadow-[0_0_0_4px_var(--color-tile-active-ring)]'
                                                  : isCompleted
                                                    ? 'wf-tile bg-[color:var(--color-tile-done-bg)] text-[color:var(--color-tile-done-fg)] border border-[color:var(--color-tile-done-line)]'
                                                    : 'wf-tile bg-[color:var(--color-tile-todo-bg)] text-[color:var(--color-text-muted)] border border-dashed border-[color:var(--color-tile-todo-line)]'
                                        }`}
                                    >
                                        {isCompleted && !locked ? (
                                            <svg className="w-5 h-5 text-[color:var(--color-tile-done-fg)]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                                            </svg>
                                        ) : (
                                            s.id < 10 ? `0${s.id}` : s.id
                                        )}
                                    </div>
                                    {isActive && !locked && (
                                        <span className="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-[color:var(--color-tile-badge)] border-2 border-[color:var(--color-bg-white)] shadow-md" />
                                    )}
                                </button>
                                <div
                                    className={`mt-2 text-[10px] font-black uppercase tracking-widest text-center ${
                                        locked ? 'text-[color:var(--color-text-muted)]' : isActive ? 'text-[color:var(--color-text-hero)]' : 'text-[color:var(--color-text-muted)]'
                                    }`}
                                >
                                    {s.title}
                                </div>
                                {locked && (
                                    <div className="text-[8px] text-[color:var(--color-warn-fg)] font-bold uppercase tracking-wide mt-1 text-center px-0.5 leading-tight">
                                        Locked
                                    </div>
                                )}
                                {isActive && !locked && s.description && (
                                    <div className="text-[10px] text-[color:var(--color-accent)] font-medium mt-0.5 text-center">{s.description}</div>
                                )}
                            </div>

                            {i !== steps.length - 1 && (
                                <div className="flex items-center self-center mt-1 flex-1 px-1">
                                    <svg className="w-full h-4 text-[color:var(--color-border-strong)]" viewBox="0 0 80 16" fill="none" preserveAspectRatio="none">
                                        <line x1="0" y1="8" x2="64" y2="8" stroke="currentColor" strokeWidth="2" strokeDasharray="4 3" />
                                        <path d="M64 4 L72 8 L64 12" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                            )}
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export default HorizontalWorkflowStepper;
